import React, { useState } from 'react';

import {
  QEmptyState,
  QEmptyStateButtonGroup,
  QEmptyStatePrimaryButton,
  QButton,
  QStack,
  QDivider,
  QText,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { routes } from 'utils';
import { ImportModal } from 'v2components';

import { ImportModalProps } from './ImportModal';

export const EmptyState: React.FC<Pick<ImportModalProps, 'refetchSuppliers'>> = ({ refetchSuppliers }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  return (
    <>
      <div data-cy="suppliers-empty-state">
        <QEmptyState title={t('supplierList.emptyState.title')} subtitle={t('supplierList.emptyState.subtitle')}>
          <QEmptyStateButtonGroup>
            <QEmptyStatePrimaryButton>
              <QButton onClick={() => navigate(`/${routes.addSupplier}`)}>
                {t('supplierList.emptyState.buttons.addSupplier')}
              </QButton>
            </QEmptyStatePrimaryButton>
          </QEmptyStateButtonGroup>
        </QEmptyState>
      </div>

      <QStack direction="row" alignItems="center" pb={4}>
        <QDivider orientation="horizontal" />
        <QText>{t('supplierList.emptyState.divider')}</QText>
        <QDivider orientation="horizontal" />
      </QStack>
      <QStack direction="column" alignItems="center" spacing={4}>
        <QButton aria-label="icon-button" size="sm" variant="outline" onClick={() => setIsModalOpen(true)}>
          {t('supplierList.emptyState.buttons.importSuppliers')}
        </QButton>
        <QButton
          aria-label="icon-button"
          size="sm"
          variant="outline"
          onClick={() => navigate(`/${routes.policyConfiguration.root}/${routes.policyConfiguration.supplierTypes}`)}
        >
          {t('supplierList.emptyState.buttons.configurePolicy')}
        </QButton>
        <ImportModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} refetchSuppliers={refetchSuppliers} />
      </QStack>
    </>
  );
};
